import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHome4Fill = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_134_1653)",
		children: /* @__PURE__ */ _jsx("path", { d: "M13.2 2.65C12.4889 2.11667 11.5111 2.11667 10.8 2.65L3.8 7.9C3.29639 8.27771 3 8.87049 3 9.5V19C3 20.1046 3.89543 21 5 21H8.9C9.50751 21 10 20.5075 10 19.9V15C10 13.8954 10.8954 13 12 13C13.1046 13 14 13.8954 14 15V19.9C14 20.5075 14.4925 21 15.1 21H19C20.1046 21 21 20.1046 21 19V9.5C21 8.87049 20.7036 8.27771 20.2 7.9L13.2 2.65Z" })
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_134_1653",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgHome4Fill;
